import React from "react";
import { useSelector } from "react-redux";

import { ColorGray, ColorTestPilot, IgTypography } from "@intelligems/ig-theme";
import { Link } from "@mui/material";

import { useExperienceAnalysisData } from "../../../../api/ai/experence-analysis-data";
import { useGetOrg } from "../../../../api/organizations/get-organization";
import { experienceAnalysis } from "../../../../store/slices/ai";

interface AiDisclaimerProps {
  show?: boolean;
}

export const AiDisclaimer = ({ show }: AiDisclaimerProps) => {
  const downloadData = useExperienceAnalysisData();
  const analysis = useSelector(experienceAnalysis);
  const org = useGetOrg();

  return (
    <IgTypography sx={{ color: ColorGray.contrastText, fontSize: "12px" }}>
      AI-generated results may be incorrect or outdated. Always practice good
      judgement when interpreting results.{" "}
      {analysis.experience && analysis.createdAt ? (
        <Link
          underline={"hover"}
          sx={{
            fontSize: "12px",
            color: ColorTestPilot.blue,
            "&:hover": { color: ColorTestPilot.hoverBlue, cursor: "pointer" },
          }}
          onClick={(e) => {
            if (!downloadData.isPending) {
              downloadData.mutate(
                {
                  body: {
                    createdAt: analysis.createdAt!,
                    experienceId: analysis.experience!.id!,
                    fileType: e.shiftKey ? "jsonl" : "csv",
                    shopId: org.data.org.shopId!,
                  },
                  pathParams: undefined,
                  queryParams: undefined,
                },
                {
                  onSuccess: (data) => {
                    window.open(data.url, "_blank");
                  },
                }
              );
            }
          }}
        >
          Download dataset.
        </Link>
      ) : null}
    </IgTypography>
  );
};
